import { render, staticRenderFns } from "./UserCompanyCreate.vue?vue&type=template&id=0d4e2f09&"
import script from "./UserCompanyCreate.vue?vue&type=script&lang=js&"
export * from "./UserCompanyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports